import { TenantStorage } from '../../session/session-decode';

/**
 * Dígitos do `schema` do tenant ativo; `undefined` quando não há tenant.
 * Espelha `getOnlyNumberIdenfiersTenant`.
 */
export function getTenantIdentifier(tenant: TenantStorage | null): string | undefined {
  if (!tenant) {
    return undefined;
  }

  return (tenant.schema ?? '').replace(/\D+/g, '');
}
